import cx from 'classnames'

import {
  AlertCircleInverted,
  CheckCircleInverted,
  Info,
  MissingDataInverted,
} from 'common/icons'
export type Type = 'success' | 'error' | 'info' | 'warn'

const iconProps = {
  className: 'mr-2 w-4',
  isDefaultColor: false,
}

type Props = {
  type: Type
  className?: string
  showIcon?: boolean
  'data-testid'?: string
}

const Alert: React.FC<Props> = ({
  type,
  showIcon,
  children,
  className = '',
  'data-testid': dataTestId = 'alert',
}) => {
  let typeClassName: string = ''
  let icon: React.ReactNode = null

  switch (type) {
    case 'success':
      typeClassName = 'bg-RAGGreen text-white border-RAGGreen'
      icon = (
        <CheckCircleInverted
          {...{
            ...iconProps,
            className: `${iconProps.className} text-RAGGreen`,
          }}
        />
      )
      break
    case 'error':
      typeClassName = 'bg-RAGred text-white border-RAGred'
      icon = (
        <AlertCircleInverted
          {...{
            ...iconProps,
            className: `${iconProps.className} text-white`,
          }}
        />
      )
      break
    case 'info':
      typeClassName = 'bg-base-100 text-base-700 border-base-100'
      icon = <Info {...iconProps} />
      break
    case 'warn':
      typeClassName = 'bg-RAGamber text-white border-RAGamber'
      icon = (
        <MissingDataInverted
          {...{
            ...iconProps,
            className: `${iconProps.className} text-RAGamber`,
          }}
        />
      )
      break

    default:
      break
  }

  return (
    <div
      data-testid={dataTestId}
      className={cx(
        'flex items-center p-4 border font-medium',
        typeClassName,
        className
      )}
    >
      {showIcon && icon}
      {children}
    </div>
  )
}

export default Alert
